import {
  CompoundConditionNodeOutputData,
  RemoteCompoundConditionNodeOutputData,
} from 'common/src/modules/decisionTree/decisionTree.types';
import {DateTime} from 'luxon';

export default function convertOutputsToClientModel(
  outputs: RemoteCompoundConditionNodeOutputData[],
): CompoundConditionNodeOutputData[] {
  return outputs.map((output) => ({
    ...output,
    sections: output.sections?.map((section) => ({
      ...section,
      rules: section.rules.map((rule) => ({
        ...rule,
        ruleValue: {
          ...rule.ruleValue,
          ...(rule.ruleValue?.datesRange && {
            datesRange: {
              from: DateTime.fromISO(rule.ruleValue.datesRange.from).setZone('utc'),
              to: DateTime.fromISO(rule.ruleValue.datesRange.to).setZone('utc'),
            },
          }),
          ...(rule.ruleValue?.dateValues && {
            dateValues: rule.ruleValue.dateValues.map((date) =>
              DateTime.fromISO(date).setZone('utc'),
            ),
          }),
        },
      })),
    })),
  }));
}
